module.exports = __webpack_public_path__ + "img/case_bibblebabble_portrait.5e27afba.jpg";